module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eQYpL"))).then(() => parcelRequire('1iHdE'));